import { ThemeEvents } from '@theme/events';

class BbdCartUpsells extends HTMLElement {
  connectedCallback() {
    this.upsells_list = this.querySelector('.bbd-cart-upsells__list');

    this.#load();
    document.addEventListener(ThemeEvents.cartUpdate, this.#load.bind(this));
  }
  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#load.bind(this));
  }

  async #load() {
    this.classList.add('loading');
    const cart = await fetch('/cart.js').then((res) => res.json());
    let blocksToAdd = [];

    for (const item of cart.items) {
      const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${item.product_id}&intent=${this.dataset.intent}&limit=3`;

      try {
        const res = await fetch(url);
        const html = await res.text();

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const blocks = temp.querySelectorAll('.bbd-cart-upsells-item');
        if (blocks) {
          blocks.forEach((block) => {
            blocksToAdd.push(block);
          });
        }
      } catch (err) {
        console.warn('Fout bij ophalen upsell voor', item.handle, err);
      }
    }

    if (blocksToAdd.length > 0) {
      blocksToAdd = blocksToAdd.filter(this.filterByHandle);
      this.upsells_list.innerHTML = '';

      blocksToAdd.forEach((block) => {
        this.upsells_list.appendChild(block);
      });

      this.classList.remove('loading');
    }
  }

  filterByHandle(value, index, array) {
    // Assumes each block has a data-handle attribute
    return array.findIndex((el) => el.dataset.handle === value.dataset.handle) === index;
  }
}

if (!customElements.get('bbd-cart-upsells')) {
  customElements.define('bbd-cart-upsells', BbdCartUpsells);
}
